import { render, staticRenderFns } from "./Nuages.vue?vue&type=template&id=52093045"
import script from "./Nuages.vue?vue&type=script&lang=js"
export * from "./Nuages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports